module.exports = __webpack_public_path__ + "static/media/Editar.1a681584.svg";